module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "89599.png",
      "src": "OEBPS/image/89599.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader"
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("It was ten before I saw any activity in the area. I couldn’t resist going outside every now and then to see how the painting was coming along. The artist had an eye for design and was able to capture the best angle of the house. When I saw a well-dressed man walk into the shop, I went back inside to see if I could help him.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Hello, I’m Harold Carpenter from a newspaper called the ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Daily Press")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Nice to meet you,” I responded. “How can I help you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ve read your columns in ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(" magazine. We’re looking for someone to write a weekly column for us. It would give you three times the exposure, and more income as well. Would that interest you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh!” I said, surprised.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I know that your column is very popular. We want the same type of content. We’re interested in you because you are a local resident and a business owner.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Mr. Carpenter, I’m flattered, but I barely have time to write my monthly column, much less a weekly one. I’m afraid that I have to decline.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I didn’t mean to put you on the spot,” he apologized. “Would you think about it for a while? I’ll leave my card in case you have any questions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ll take your card, of course, but my answer will remain the same. ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(" magazine has been very good to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It was nice to meet you,” he said kindly. “After you’ve had some time to consider it, I think you’ll realize that this is something that could be very good for your future.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I watched him as he left and couldn’t help smiling to myself. What were the chances of this happening? I knew there was no way that I could take on any more responsibilities. I couldn’t wait to tell Alex! ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("As more and more customers came into the shop, it took my mind off Mr. Carpenter. Every time I looked out the window, there was a crowd around the artist. I wondered if she’d had any other offers on her painting.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("The next morning, I woke up realizing that I had my evening dinner date with Marc to look forward to. The dinner sounded somewhat dressy, so I would have to choose one of my many black outfits. Since I didn’t know the other couple, I realized that I felt a bit nervous. As the day wore on, I informed my artist that I would be closing early, and she agreed to leave early as well. As I was thinking of closing, I got a call from Alex.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Guess what, Lily Girl?” he asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I could tell that he was particularly excited about something. “What?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I decided to lease a car instead of buying one again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Okay, so what’s the big deal about that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It’s a convertible! A red convertible! Jealous?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Good heavens, Alex! Are you going through some kind of midlife thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Maybe!” he said, chuckling. “The accident on New Year’s Eve caused me to have to get a different vehicle. I put it off as long as I could, and now I’ve finally made a decision. I’m so excited about this car! I can’t wait to drive out to Augusta and speed around those curves.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Not funny, Alex,” I warned. “I hope you don’t plan to come this weekend, because I’m going in to meet Marc. He’s taking a client and his wife to dinner, so I’m joining him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So much for that,” Alex said, sounding deflated.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I have a little excitement of my own to share, by the way. I recently received a job offer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Really?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I told him about my visit from Mr. Carpenter. I could tell by Alex’s silence that he was jealous and didn’t quite know what to say. He paused before he responded.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So, what did you decide, Lily Girl?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I turned him down, of course. The thought of adding more to my life right now is crazy. I couldn’t take all that pressure. That’s why I’m out here in Augusta.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You know those offers don’t come along every day, don’t you?” Alex questioned.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I know. I did take his card because that seemed to make him feel better.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Alex chuckled. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I need to get going. Enjoy your new toy!”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bbf095","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/quilt-left-behind_split12.vue
// module id = 96
// module chunks = 0